export default "__VITE_ASSET__CpKbhaM1__"